import Timeline from './timeline/Timeline';
import store from './store/store';
import Controls from './controls/Controls';
import ConfigForm from './config_form/ConfigForm'
import('./timelinecontrol.scss')

export default function TimeLineControl(opts={}){
    BaseConstructor.call(this)
    let {
        container,
        options={contentType:'imageOverlay', imageBounds:{}, speed: 2, play:true},
        position={position:'bottom-mid'},
        map,
        states=[
            {title:'teste', content: 'http://localhost:3000/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBbndCIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--48fad894f54337eec71dad63ee15a9e7bbcbedbd/202401252115.png'},
            {title:'teste2', content: "http://localhost:3000/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBdmdCIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--91b78a6e32bb545633c48fb4ccb33dc98d3ff5eb/202401260730.png"}
        ]} = opts
        
    let elements = {}
    let context = this
    let current_index = 0
    let INTERVAL
    let featureGroup //feature que vai armazenar o content do state (layer ou imagem)
    let _controls, _timeline
    let deferredDownloading = []

    this.generate = () =>{
        elements.container = this.createElement('div', `timelinecontrol-container ${position.position}`)
        elements.controls_container = this.createElement('div', 'timelinecontrol-controls-container')
        elements.timeline_container = this.createElement('div', 'timelinecontrol-timeline-container')
        
        $(elements.container).append(elements.controls_container, elements.timeline_container)

        $(map._container).append(elements.container)

        generateControls()
        generateTimeline()
        generateConfigForm()

        $.when(...deferredDownloading).then((...results) => {
            this.showState(states.length-1)
            store.setOption('play', opts.play)
        }).fail((error) => {
            console.error('Error:', error);
        });
    }

    this.update = (new_states = []) =>{
        store.setOption('play', false)//sempre iniciar quando o componente for gera
        
        if(new_states.length > 0){
            states = new_states
        }

        let promises = []
        
        states.forEach(state=>{
            promises.push($.ajax({url: state.content, xhrFields: {
                responseType: 'blob' // Set the response type to Blob
            }}).then(data=>{
                //adicionando url de objeto cliente como url que será utilizada para a imageOverlay
                state.url = URL.createObjectURL(data)
            }))
        })

        Promise.all(promises).then(data=>{
            context.showState(current_index)
            store.setOption('play', store.getOption('play'))//sempre iniciar quando o componente for gera
            
            if(_timeline){
                _timeline.updateStates(states)
            }

        })

        
    }

    this.destroy = () =>{
        context.stop()
        $(elements.container).html('')
        if(featureGroup){
            map.removeLayer(featureGroup)
            featureGroup=null
        }
        if(_timeline){
            _timeline.destroy()
        }
        if(_controls){
            _controls.destroy()
        }

        setOptionHandler = _=> {return null}
    }

    this.stop = _=>{
        if(INTERVAL){
            clearInterval(INTERVAL)
        }
    }

    this.play = (from) =>{
        
        current_index = from || current_index

        if(INTERVAL){
            this.stop()
        }
        
        INTERVAL = setInterval(_=>{
            current_index = context.showState(current_index)
        }, (options.speed||2) * 1000)
        
    }

    this.showState = (index) =>{
        let state = states[index]
            
        if(state){
            console.log(state);
            store.setOption('current_active', state.title)
            index ++
        } else {
            index = 0
        }   

        return index
    }
    
    const generateTimeline = () =>{
        _timeline = new Timeline({states:states, container:elements.timeline_container})
        _timeline.generate()

    }

    const generateControls = _ =>{
        _controls = new Controls({container:elements.controls_container})
        _controls.generate()
    }

    const generateConfigForm = _ =>{
        let configForm = new ConfigForm({container:elements.container})
    }
    const setOpacity = _ =>{
        let value = store.getOption('opacity')
        featureGroup.setStyle({
            opacity: value
        })
    }

    const setSpeed = _ =>{
        let value = store.getOption('speed')
        options.speed = value
        context.play()
    }

    let setOptionHandler = data=>{
        if(data.option === 'play'){
                
            if(data.value === true){
                context.play()
                store.setOption('fixed', false)
            } else {
                context.stop()
            }
        }  else if(data.option === 'current_active'){
            let index = states.findIndex(x=>x.title === store.getOption('current_active'))
            if(index!=-1){
                let state = states[index]
                context.trigger('CHANGE_STATE',state)

                current_index = index

                if(!featureGroup){
                    featureGroup = new L.featureGroup()
                    map.addLayer(featureGroup)
                }
                if(options.contentType === 'imageOverlay'){
                    let imageBounds = [[-21.425445, -48.290929], [-25.740584, -43.577082]];
                    console.log(featureGroup);
                    featureGroup.clearLayers()
                    
                    let over = L.imageOverlay(state.url, imageBounds,{interactive: true})
                    console.log(state.downloading);
                    over.addTo(featureGroup)

                    over.on('click', e =>{
                        console.log(e, this);
                    })
                    setOpacity()
                    featureGroup.bringToFront()
                }
            }
            
        } else if(data.option === 'opacity'){
            setOpacity()                
        } else if(data.option === 'speed'){
            setSpeed()
        } else if(data.option === 'fixed'){
            if(data.value){
                let state = states[states.length - 1]
                store.setOption('current_active', state.title)
            }               
        }
    }

    init()

    function init(){
        deferredDownloading = []
        if(options.speed){
            store.setOption('speed', options.speed)
        }
        store.subscribe('SET_OPTION', data=>{
            setOptionHandler(data)
        })

        //fazendo o download de todas as imagens para não precisar fazer downloads em tempo de execução
        states.forEach(state=>{
            let deferred = $.Deferred();
            deferredDownloading.push(deferred)

            $.ajax({url: state.content, xhrFields: {
                responseType: 'blob' // Set the response type to Blob
            }}).then(data=>{
                //adicionando url de objeto cliente como url que será utilizada para a imageOverlay
                state.url = URL.createObjectURL(data)
                deferred.resolve()
            })
        })
    }

}

TimeLineControl.prototype = Object.create(BaseConstructor.prototype)